import {
	MinusOutlined,
	PlusOutlined,
	QuestionCircleOutlined,
} from "@ant-design/icons";
import { Form, Radio, Switch, Tooltip, theme } from "antd";
import * as COMMONS from "common/common";
import { useParams } from "react-router-dom";
import { useToggle, useSearchParam } from "react-use";

import CategoryCancelConditions from "./CategoryCancelConditions";
import CustomReservationMessage from "./CustomReservationMessage";
import Fee from "./Fee";
// import GroupBooking from "./GroupBooking"
// import TimedEventSettings from "./TimedEventSettings"

const EventSettingsDetail = ({ currentCategory }) => {
	const isProgram = useSearchParam("isProgram");
	const [collapse, toggleCollapse] = useToggle(false);
	const { colorPrimary } = theme.useToken().token;
	const { categoryId } = useParams();

	return (
		<motion variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM}>
			<div
				onClick={toggleCollapse}
				className="h-9 px-6 bg-[#E4E5E9] flex items-center justify-between cursor-pointer"
			>
				<span></span>
				<span className="select-none">イベント設定詳細</span>
				<div className="border border-[#707070] border-solid rounded w-4 h-4 leading-[14px]">
					{collapse ? <MinusOutlined /> : <PlusOutlined />}
				</div>
			</div>

			{collapse && (
				<motion
					variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM}
					className="flex flex-col mt-6 gap-y-4"
				>
					{isProgram === "true" ? null : (
						<div className="flex items-center gap-x-4">
							<div className="flex gap-x-2">
								<span>イベントプログラム設定</span>
								<Tooltip
									overlayInnerStyle={{
										width: 300,
									}}
									title={
										<div>
											<div>
												イベントの詳細プログラム毎に予約を分けたい場合は「あり」を選択ください。
											</div>
										</div>
									}
								>
									<QuestionCircleOutlined
										style={{
											color: colorPrimary,
										}}
									/>
								</Tooltip>
							</div>
							<Form.Item noStyle name="isProgram">
								<Switch disabled={!!categoryId} />
							</Form.Item>
						</div>
					)}

					<Form.Item
						noStyle
						shouldUpdate={(prevValues, currentValues) =>
							prevValues.isProgram !== currentValues.isProgram
						}
					>
						{({ getFieldValue }) => {
							const isProgram = getFieldValue("isProgram");
							return !isProgram ? (
								<>
									<div className="border rounded-md border-[#CCCCCC] border-dashed px-5 py-3 flex flex-col gap-y-2">
										<div className="flex gap-x-4 h-8 items-center">
											<div className="flex gap-x-2">
												<span>他イベントとの同時予約</span>
												<Tooltip
													title={
														<div>
															<div>■OKの場合</div>
															<div>・予約者は他イベントにも予約できます。</div>
															<div>■NGの場合</div>
															<div>
																・予約者はイベント終了まで他イベントに予約できなくなります。
															</div>
															<div>
																・他イベント予約者はこのイベントには予約できなくなります。
															</div>
														</div>
													}
													overlayInnerStyle={{
														width: 450,
													}}
												>
													<QuestionCircleOutlined
														style={{
															color: colorPrimary,
														}}
													/>
												</Tooltip>
											</div>
											<Form.Item noStyle name="isMultiEvent">
												<Radio.Group disabled>
													<Radio value={true}>OK</Radio>
													<Radio value={false}>NG</Radio>
												</Radio.Group>
											</Form.Item>
										</div>

										<Form.Item
											noStyle
											dependencies={["isSettingTime", "isMultiEvent"]}
										>
											{({ getFieldValue }) => {
												const isSettingTime = getFieldValue("isSettingTime");
												const isMultiEvent = getFieldValue("isMultiEvent");
												return !isSettingTime && isMultiEvent ? (
													<div className="flex gap-x-4 h-8 items-center">
														<div className="flex gap-x-2">
															<span>他イベントとの時間重複予約</span>
															<Tooltip
																title={
																	<div>
																		<div>■OKの場合</div>
																		<div>
																			・時間が重複していても他イベントと重複予約できます。
																		</div>
																		<div>■NGの場合</div>
																		<div>
																			・時間が重複している場合は予約できなくなります。
																		</div>
																	</div>
																}
																overlayInnerStyle={{
																	width: 390,
																}}
															>
																<QuestionCircleOutlined
																	style={{
																		color: colorPrimary,
																	}}
																/>
															</Tooltip>
														</div>
														<Form.Item
															noStyle
															name="notRegisterEventSameTime"
															valuePropName="value"
														>
															<Radio.Group>
																<Radio value={false}>OK</Radio>
																<Radio value={true}>NG</Radio>
															</Radio.Group>
														</Form.Item>
													</div>
												) : null;
											}}
										</Form.Item>

										{/* <GroupBooking /> */}

										{isProgram ? null : <Fee />}

										<CustomReservationMessage />

										{isProgram ? null : <CategoryCancelConditions />}
									</div>
									{/* <TimedEventSettings currentCategory={currentCategory} /> */}
								</>
							) : null;
						}}
					</Form.Item>
				</motion>
			)}
		</motion>
	);
};

export default EventSettingsDetail;
